import React, { Component } from 'react';
import { format } from "date-fns";
import { Big3Common, bootstrap } from '../../js/IncludeManager'
import { PwCheck } from './PwCheck';
import { Alert } from "../../js/ComponentManager";

/* 개발담당:이재호
 * 화면기능:결제창
 * 세부설명:
*/
export class ChargePoint extends Component {
    static displayName = ChargePoint.name;

    constructor(props) {
        super(props);
        this.state = {
            Amount: "",
            Clod_Point: "",
            Card_Info: "",
            Content: "",
        };
        this.CsName = Big3Common.ContentState;
        this.GetPoint = this.GetPoint.bind(this);
        this.handle_Change = this.handle_Change.bind(this);
        this.handle_amount = this.handle_amount.bind(this);
        this.date = format(Big3Common.Util.DateAdd(new Date(), 0), "yyyy-MM-dd");
        this.PwCheckRef = React.createRef();

        this.depo_idx = 'IN'
        this.depo_cd = 'PO'
    }
    //초기화
    async componentDidMount() {
        this.GetPoint()
        this.GetCardInfo()
    }
    //포인트 조회
    async GetPoint() {
        try {
            let Data = await Big3Common.Post("api/Common/Common/GetPoint", {}, true);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                const DataList = JSON.parse(Data.dataTable);
                const Clod_Point = DataList[0]["total_point"]
                this.setState({
                    Clod_Point: Clod_Point
                })
            }
            else {
                alert(Data.message);
            }
        }
        catch (e) {
            console.log("GetPoint: ", e)
        }
        return false;
    }
    //카드정보 조회
    async GetCardInfo() {
    try {
        let Data = await Big3Common.Post("api/Common/Common/GetCardInfo", {}, true);
        if (Data.codeName === Big3Common.ResultCode.Success) {
            let card_info = JSON.parse(Data.multiDataTable);
            this.setState({
                Card_Info: card_info.card
            })
        }
        else {
            alert(Data.message);
        }
    }
    catch (e) {
        console.log("GetCardInfo: ", e)
    }
    return false;
    }
    async requestPayment() {
        try {
            let Data = await Big3Common.Post("api/Common/Common/ChargePoint", {
                paymentId: Big3Common.getGuid(),
                depo_dt: this.date,
                depo_idx: this.depo_idx,
                depo_cd: this.depo_cd,
                amount: this.state.Amount
            }, true);

            if (Data.codeName === Big3Common.ResultCode.Success) {
                this.props.RenderComponent('PointCheck',{ Amount: this.state.Amount, Clod_Point: this.state.Clod_Point, Card_Info: this.state.Card_Info });
            } else {
                this.setState({ Content: Data.message });
                Big3Common.ModalAlert(bootstrap, "Fail");
            }

        } catch (e) {
            console.log("handle_PointCharge: ", e);
        }
        return false;
    }
    handle_Change(event) {
        const value = event.target.value.replace(/,/g, '');;
        this.setState({
            Amount: value
        });
        event.preventDefault();
    }
    handle_amount(e, amount) {
        this.setState({
            Amount: amount
        })
    }
    handle_PwCheck = async (event) => {
        Big3Common.ModalAlert(bootstrap, "PwCheck");
        event.preventDefault();
    }
    render() {
        const amount = this.state.Amount
        const clod_point = this.state.Clod_Point
        const sum_point = Number(amount) + Number(clod_point);
        const card_info = this.state.Card_Info;

        return (
            <div className="container_box p_b_margin c_padding">
                <div className="point_info">
                    <p>클로디포인트 충전 시 주의 사항</p>
                    <ul>
                        <li>클로디포인트 충전은 <span>카드 결제</span>로만 가능합니다.</li>
                        <li>클로디포인트는 <span>선불 충전</span> 및 <span>자동 충전</span>으로 운영되고 있습니다.</li>
                        <li>주문완료 후 포인트 차감시 현재 포인트가 부족하다면 등록된 카드로 <span>자동 충전</span>됩니다.</li>
                        <li>환불 시, <span>환불 수수료</span>로 충전 금액의 <span>10%</span>가 발생합니다.</li>
                    </ul>
                </div>
                <div className="point_chargebox margin_top">
                    <div className="title_box">
                        <div className="title">포인트 충전</div>
                    </div>
                    <div className="select_amount flex_fs">
                        <div className="amount" onClick={(e) => { this.handle_amount(e, '10000'); }}>+1만원</div>
                        <div className="amount" onClick={(e) => { this.handle_amount(e, '30000'); }}>+3만원</div>
                        <div className="amount" onClick={(e) => { this.handle_amount(e, '50000'); }}>+5만원</div>
                        <div className="amount" onClick={(e) => { this.handle_amount(e, '100000'); }}>+10만원</div>
                    </div>
                    <div className="d_info_txt">최고 충전 금액 : 100,000원</div>
                </div>

                <div className="point_chargebox point_check_box">
                    <div className="title_box">
                        <div className="title">포인트 확인</div>
                    </div>
                    <div className="point_check_list">
                        <div className="point_check flex_sb">
                            <div className="title">충전 희망금액</div>
                            <div className="recharge_amount">+{Big3Common.Util.Money(amount)}원</div>
                        </div>
                        <div className="point_check flex_sb">
                            <div className="title">충전수단</div>
                            <div className="points">{card_info}</div>
                        </div>
                        <div className="point_check flex_sb">
                            <div className="title">현재 보유포인트</div>
                            <div className="points">{Big3Common.Util.Money(clod_point)}P</div>
                        </div>
                    </div>
                    <div className="point_check total_point flex_sb">
                        <div className="title">충전 후 보유포인트</div>
                        <div className="available_points">{Big3Common.Util.Money(sum_point)}P</div>
                    </div>
                </div>


                <div className="catagory_button_box">
                    {
                        amount === "" ?
                            <button type="button" className="btn_v btn_inactive" data-bs-toggle="modal" data-bs-target="#id_check">충전</button>
                            :
                            <button type="button" className="btn_v btn_v1" onClick={(e) => { this.handle_PwCheck(e); }}>충전</button>
                    }
                    
                    
                </div>
                <PwCheck id="PwCheck"
                    ref={this.PwCheckRef}
                    requestPayment={this.requestPayment.bind(this)}
                />
                <Alert
                    id="Fail"
                    content={this.state.Content}
                    title="충전안내"
                />
            </div>
        )
    }
}
